import React from 'react';
import {Shield, Star, Phone, FileCheck, Clock, HandshakeIcon} from 'lucide-react';
import '../styles/main.css';

const mainServices = [
    {
        icon: <FileCheck className="service-icon w-6 h-6 md:w-8 md:h-8"/>,
        text: 'Negocierea și încheierea polițelor de asigurare pentru toate tipurile de asigurări și cu cele mai puternice societăți de asigurări, ca de exemplu:'
    },
];
const secondList = [
    {
        icon: <Shield className="service-icon w-4 h-4 md:w-6 md:h-6"/>,
        text: 'Asigurări auto: RCA, CASCO, CMR.'
    },
    {
        icon: <Shield className="service-icon w-4 h-4 md:w-6 md:h-6"/>,
        text: 'Asigurarea utilajelor neînmatriculate (agricole, construcții, drumuri etc).'
    },
    {
        icon: <HandshakeIcon className="service-icon w-4 h-4 md:w-6 md:h-6"/>,
        text: 'Asigurări agricole, inclusiv secetă, îngheț timpuriu, îngheț târziu.'
    },
    {
        icon: <HandshakeIcon className="service-icon w-4 h-4 md:w-6 md:h-6"/>,
        text: 'Asigurarea clădirilor și bunurilor (IF, PFA, Asociații, PJ etc), inclusiv pierderi de profit în caz de eveniment asigurat.'
    },
    {
        icon: <Shield className="service-icon w-4 h-4 md:w-6 md:h-6"/>,
        text: 'Asigurarea panourilor solare.'
    },
    {
        icon: <Clock className="service-icon w-4 h-4 md:w-6 md:h-6"/>,
        text: 'Asigurări echipamente electronice, servere, drone, protecție împotriva atacurilor cibernetice.'
    },
    {
        icon: <Shield className="service-icon w-4 h-4 md:w-6 md:h-6"/>,
        text: 'Asigurarea locuințelor (PAD-Obligatorie și Facultativă).'
    },
    {
        icon: <FileCheck className="service-icon w-4 h-4 md:w-6 md:h-6"/>,
        text: 'Asigurări medicale pentru călătorii în străinătate, accidente, sănătate.'
    },
    {
        icon: <FileCheck className="service-icon w-4 h-4 md:w-6 md:h-6"/>,
        text: 'Asigurări de Bunuri și Persoane pe timpul transportului.'
    },
    {
        icon: <Clock className="service-icon w-4 h-4 md:w-6 md:h-6"/>,
        text: 'Asigurări de răspundere civilă (producători, prestatori de servicii, chiriași) și profesională (avocați, notari, juriști, experți, contabili, medici, personal medical, lichidatori, manageri, membrii CA etc).'
    },
    {
        icon: <HandshakeIcon className="service-icon w-4 h-4 md:w-6 md:h-6"/>,
        text: 'Asigurări de garanții (ARR, participare la licitații, garanții buna execuție, returnare avans, garanții comerciale).'
    },
    {
        icon: <Shield className="service-icon w-4 h-4 md:w-6 md:h-6"/>,
        text: 'Asigurarea lucrărilor de construcții-montaj (CAR).'
    },
]

const secondServiceList = [
    {
        icon: <FileCheck className="service-icon w-6 h-6 md:w-8 md:h-8"/>,
        text: <>
            <a href="mailto:doina.tomuleanu@renomia.ro"
               className="text-green-600 hover:text-green-800">
                {'Asistență gratuită '}
            </a>
            {'pe toată durata valabilității polițelor de asigurări (acte adiționale, ' +
                'înștiințări/incasare rate, rezilieri).'}
        </>
    },
    {
        icon: <FileCheck className="service-icon w-6 h-6 md:w-8 md:h-8"/>,
        text: <>
            {'Asistență în legătură cu '}
            <a href="mailto:gheorghe.tomuleanu@renomia.ro"
               className="text-green-600 hover:text-green-800">
                {' obținerea de despăgubiri '}
            </a>
            {'de la asiguratori și întocmirea dosarelor de daună, inclusiv Carte Verde.'}
        </>
    },
    {
        icon: <Star className="service-icon w-6 h-6 md:w-8 md:h-8"/>,
        text: <>
            <a href="mailto:gheorghe.tomuleanu@renomia.ro"
               className="text-green-600 hover:text-green-800">
                {'Inspecții de risc'}
            </a>
            {' în vederea obținerii ofertelor de asigurare de la asiguratori.'}
        </>
    }
];

export const Services: React.FC = () => {
    return (
        <div
            className="card-content text-xl font-font-s text-bg-gray p-0 md:p-10 w-full md:w-9/12 gap-5 flex flex-col">
            <div>
                <p className="font-font-s text-2xl font-semibold mb-5">
                    {'Cine suntem?'}
                </p>
                <p className={'text-center mb-5 text-justify'}>
                    {
                        'Suntem o societate de intermediere în asigurări, franciza Renomia Insurance Reinsurance Broker, specializata ' +
                        'să vă ofere soluții personalizate și adaptate nevoilor dumneavoastră. ' +
                        'Cu o echipă de profesioniști care au o experiență de peste 20 ani și parteneriat solid cu unul dintre cei mai ' +
                        'importanti brokeri de asigurari din CEE, vă asigurăm suportul necesar pentru a lua cele mai bune decizii ' +
                        'privind protejarea patrimoniului dvs. , inclusiv a membrilor familiei sau angajatilor dvs, asigurari de sanatate, ' +
                        'pensii private si nu in ultimul rand asigurari de garantii, raspundere personala si profesionala.'
                    }
                </p>
                <p className="font-font-s text-2xl mb-5">
                    {'Pe scurt: TOATE TIPURILE DE ASIGURARI!'}
                </p>

                <p className={'text-center mb-5 text-justify'}>
                    {'STAR INSURANCE SPECIALIST SRL are sediul social in Municipul Botosani, str. ' +
                        'Armeana nr. 50, Cod postal 710359, Judetul Botosani si isi desfasoara activitatea de ' +
                        'intermediere in asigurari la sediile situate in Municipiul Botosani, Judetul Botosani:'}
                </p>
                <div className={'mb-5'}>
                    <p className={'text-center text-justify'}>
                        {'1. Piata Revolutiei nr. 13, parter, (in spatele Teatrului Mihai Eminescu, langa Prefectura, CEC Bank si Galeriile de arta Stefan Luchian), '}
                    </p>

                    <div className={'flex flex-row gap-3'}>
                        {'Tel: '}
                        <a href="tel:0331402564" className="text-green-600 hover:text-green-800">
                            0331.402.564
                        </a>
                    </div>

                    <div className={'flex flex-row gap-3'}>
                        {'Mobil/WhatsApp: '}
                        <a href="https://wa.me/40740207134" target="_blank" rel="noopener noreferrer"
                           className="text-green-600 hover:text-green-800">
                            0740.207.134
                        </a>
                    </div>
                </div>

                <div className={' mb-5 '}>
                    <p className={'text-centertext-justify'}>
                        {'2. Str. Armeana nr. 50, (Piata Mare, langa Biserica Armeneasca veche), '}
                    </p>

                    <div className={'flex flex-row gap-3'}>
                        {'Tel: '}
                        <a href="tel:0331402564" className="text-green-600 hover:text-green-800">
                            0331.402.564
                        </a>
                    </div>
                    <div className={'flex flex-row gap-3'}>
                        {'Mobil/WhatsApp: '}
                        <a href="https://wa.me/40740039340" target="_blank" rel="noopener noreferrer"
                           className="text-green-600 hover:text-green-800">0740.039.340
                        </a>
                    </div>
                </div>

                <div className={'flex flex-col gap-3 mb-5'}>
                    <p className="font-font-s text-2xl font-semibold ">
                        {'Produsele/Serviciile noastre'}
                    </p>
                    <div
                        className="services flex flex-col font-font-s gap-4 items-center md:items-start justify-center mb-5">
                        {mainServices.map((mainService, mainIndex) => (
                            <div key={`main-service-${mainIndex}`} className="flex flex-col w-full gap-2">
                                <div className="service-item flex flex-row gap-1 items-center w-full ">
                                    <p className={'w-1/12'}>{mainService.icon}</p>
                                    <p className={'w-11/12 font-font-s text-justify'}>{mainService.text}</p>
                                </div>
                                {secondList.map((service, index) => (
                                    <div
                                        key={`second-list-${mainIndex}-${index}`}
                                        className="text-base pl-10 service-item flex flex-row gap-1 items-center w-full md:w-4/5"
                                    >
                                        <p className={'w-1/12'}>{service.icon}</p>
                                        <p className={'w-11/12 font-font-s text-justify'}>{service.text}</p>
                                    </div>
                                ))}
                            </div>
                        ))}
                        {secondServiceList.map((service, index) => (
                            <div key={index} className="service-item flex flex-row gap-1 items-center w-full">
                                <p className={'w-1/12'}>{service.icon}</p>
                                <p className={'w-11/12 font-font-s text-justify'}>{service.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div className={'flex flex-col gap-3 justify-center md:justify-start'}>
                    <p className="font-font-s text-2xl font-semibold">
                        {'De ce să ne alegeți?'}
                    </p>

                    <ol className={'flex flex-col gap-3 justify-center md:justify-start'}>
                        <li className="font-font-s text-xl italic text-center md:text-left">
                            {' - Consiliere gratuită: vă explicăm toate opțiunile disponibile și vă ajutăm să înțelegeți ' +
                                'ce se potrivește cel mai bine nevoilor dumneavoastră.'}
                        </li>
                        <li className="font-font-s text-xl italic text-center md:text-left">
                            {' - Rapiditate și eficiență: acces la oferte competitive și soluții personalizate, fără să pierdeți timp.'}
                        </li>
                        <li className="font-font-s text-xl italic text-center md:text-left">
                            {' - Transparență totală: colaborăm deschis, punând mereu interesele clientului pe primul loc.'}
                        </li>
                    </ol>


                    <a className={'text-center md:text-left text-2xl'}
                       href={'#contact-popup'}
                       onClick={(e) => {
                           e.preventDefault();
                           window.location.hash = 'contact-popup';
                       }}>
                        {'Contactați-ne acum!'}
                    </a>
                </div>
            </div>
        </div>
    );
}